module.exports = __webpack_public_path__ + "f74b8457fd9c2d3575629cf1584704aa.svg";